import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { NOT_REPORTING_REASON_LABEL } from "encamp-shared/src/submissions";
import { SubmissionNotReportingReason } from "generated-graphql/graphql";

const REASON_OPTIONS = [
  SubmissionNotReportingReason.OutOfContractScope,
  SubmissionNotReportingReason.NotApplicableToActivity,
  SubmissionNotReportingReason.Other,
];

interface NotReportingReasonInputProps {
  reason: SubmissionNotReportingReason | "";
  note: string;
  onReasonChange: (reason: SubmissionNotReportingReason | "") => void;
  onNoteChange: (note: string) => void;
  disabled?: boolean;
}

export function NotReportingReasonInput({
  reason,
  note,
  onReasonChange,
  onNoteChange,
  disabled,
}: NotReportingReasonInputProps) {
  return (
    <>
      <FormControl fullWidth required>
        <InputLabel id="not-reporting-reason-label">Reason</InputLabel>
        <Select
          labelId="not-reporting-reason-label"
          id="not-reporting-reason"
          value={reason}
          label="Reason"
          onChange={(event) => onReasonChange(event.target.value)}
          disabled={disabled}
        >
          {REASON_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {NOT_REPORTING_REASON_LABEL[option]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        label="Details"
        value={note}
        onChange={(event) => onNoteChange(event.target.value)}
        disabled={disabled}
        required={reason === SubmissionNotReportingReason.Other}
        multiline
        minRows={2}
        fullWidth
        helperText="Add any helpful context about why these submissions are not being reported."
        sx={{ gridColumn: { sm: "1 / -1" } }}
      />
    </>
  );
}

export function isNotReportingReasonComplete(
  reason: SubmissionNotReportingReason | "",
  note: string
): boolean {
  if (!reason) {
    return false;
  }
  return reason !== SubmissionNotReportingReason.Other || note.trim().length > 0;
}
